(function GroupSaveForm($, Adzuki)
{
	"use strict";

	Adzuki.onload('Groups/add/', init);

	function init() {
		$('#groupsave-group-group_type').on('change', toggleGroupType);
		$('#groupsave-group-online_registrations').on('change', toggleOnlineRegistration);
		$('#groupsave-group-insurance_company_id').on('change', toggleInsuranceSupplier);
		$('#groupsave-group-skip_payment').on('change', handleExcludePaymentInfo);
		$('#groupsave-group-single_payment_source').on('change', handleSinglePaymentSource);
		$('#groupsave-group-departure_date').on('change', handleDepartureDate);
		$('#groupsave-group-return_date').on('change', handleReturnDate);
	}

	function toggleGroupType(ev) {
		var group_type = $(ev.currentTarget).val();
		// Hide all component fields and headings
		$('.group-component-heading').each(function hideComponentHeading(index, el) {
			$(el).addClass('hidden');
		});
		$('.group-component-field').each(function hideComponentField(index, el) {
			$(el).addClass('hidden');
		});

		// Show the selected component's fields
		if (group_type === '') {
			$('#group-component-container').addClass('hidden');
		} else {
			$('#' + group_type + '-heading').removeClass('hidden');
			$('.' + group_type + '-field').each(function showField(index, el) {
				$(el).removeClass('hidden');
			});
			$('#group-component-container').removeClass('hidden');
		}
	}

	function toggleOnlineRegistration(ev) {
		var online_registrations = $(ev.currentTarget).is(':checked');
		if (online_registrations) {
			$('#online-registrations-fields').removeClass('hidden');
		} else {
			$('#online-registrations-fields').addClass('hidden');
		}
	}

	function toggleInsuranceSupplier(ev) {
		if ($(ev.currentTarget).val() === '0') {
			$('#insurance-supplier-container').removeClass('hidden');
		} else {
			$('#insurance-supplier-container').addClass('hidden');
		}
	}

	function handleExcludePaymentInfo(ev) {
		if ($(ev.currentTarget).is(':checked')) {
			$('.payment_box').each(function disableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('checked', false);
					$(el).prop('disabled', true);
				}
			});
		} else {
			$('.payment_box').each(function enableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('disabled', false);
				}
			});
		}
	}

	function handleSinglePaymentSource(ev) {
		if ($(ev.currentTarget).is(':checked')) {
			$('.payment_box').each(function disableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('checked', false);
					$(el).prop('disabled', true);
				}
			});
		} else {
			$('.payment_box').each(function enableCheckboxes(index, el) {
				if (el !== ev.currentTarget) {
					$(el).prop('disabled', false);
				}
			});
		}
	}

	function handleDepartureDate() {
		if ($('#groupsave-groupcomponent-departure_date').val() === '') {
			$('#groupsave-groupcomponent-departure_date').val($('#groupsave-group-departure_date').val());
		}
	}

	function handleReturnDate() {
		if ($('#groupsave-groupcomponent-return_date').val() === '') {
			$('#groupsave-groupcomponent-return_date').val($('#groupsave-group-return_date').val());
		}
	}

}(jQuery, window.Adzuki || {}));